import { render, staticRenderFns } from "./recommendCommodities.vue?vue&type=template&id=b518833a&scoped=true&"
import script from "./recommendCommodities.vue?vue&type=script&lang=js&"
export * from "./recommendCommodities.vue?vue&type=script&lang=js&"
import style0 from "./recommendCommodities.vue?vue&type=style&index=0&id=b518833a&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b518833a",
  null
  
)

export default component.exports